module.exports = __webpack_public_path__ + "public/adminIcons/reviewManage.svg?b8eca279";